import React from "react";
import { Link } from "react-router-dom";
import { Rocket, Phone, Home as HomeIcon } from "lucide-react";
import { useCompany } from "@/context/CompanyContext";
import Seo from "@/components/Seo";

export default function NotFound() {
  const { company } = useCompany();
  return (
    <>
      <Seo title="Page Not Found | Aquila Air & Heating" description="The page you're looking for couldn't be found." path="/404" noindex />
      <section className="min-h-[70vh] flex items-center justify-center bg-navy text-white dot-grid" data-testid="not-found">
        <div className="text-center px-4 max-w-lg">
          <Rocket className="h-16 w-16 text-launch mx-auto" />
          <h1 className="mt-6 text-5xl font-extrabold tracking-tight">404</h1>
          <p className="mt-3 text-lg text-slate-200">Looks like this page didn't make it to orbit. Let's get you back on course.</p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/" className="inline-flex items-center justify-center gap-2 bg-launch hover:bg-launch-dark text-white font-bold py-3 px-7 rounded-md transition-colors" data-testid="nf-home"><HomeIcon className="h-5 w-5" /> Go Home</Link>
            <a href={`tel:${company.phone_href || ""}`} className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 border border-white/30 font-semibold py-3 px-7 rounded-md transition-colors"><Phone className="h-5 w-5" /> Call Us</a>
          </div>
          <div className="mt-8 flex flex-wrap gap-4 justify-center text-sm">
            <Link to="/services" className="text-cool hover:underline">Services</Link>
            <Link to="/service-areas" className="text-cool hover:underline">Service Areas</Link>
            <Link to="/blog" className="text-cool hover:underline">Blog</Link>
            <Link to="/contact-us" className="text-cool hover:underline">Contact</Link>
          </div>
        </div>
      </section>
    </>
  );
}
